// extracted by mini-css-extract-plugin
module.exports = {"pagination":"ForgotToPunch_pagination_2FR5F","paginationText":"ForgotToPunch_paginationText_1lxQ1","paginationButton":"ForgotToPunch_paginationButton_dRz3S"};